import {TableHeader, TableRow} from "../../../components/table/CustomTable";
import {useSelector} from "react-redux";
import {getFullName} from "../../../helpers/helperFunctions";
import {NORMAL_USERS, TABLE_DISPLAY_MODE_FEATURES} from "../constants";
import { USER_STATE_INACTIVE } from "../constants";


export default function ManageUserTableHeader() {

  const displayMode = useSelector((state) => state.manageUser.displayMode);
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);

  const displayFeatures = displayMode === TABLE_DISPLAY_MODE_FEATURES && selectedTab === NORMAL_USERS;


  return (
    <>


      {displayFeatures ? <ManageUserTableHeaders/> :
        <thead>
        <TableRow>
          <TableHeader>
            User
          </TableHeader>
          <TableHeader>
            State
          </TableHeader>
          <TableHeader>
            
          </TableHeader>
        </TableRow>
        </thead>
      }

    </>
  );
}


const ManageUserTableHeaders = () => {

  const selectedTab = useSelector((state) => state.manageUser.selectedTab);

  const currentPage = useSelector((state) => state.manageUser[selectedTab].meta.page);


  const {
    loading = false, init = false, data: users = [], error = ""

  } = useSelector((state) => state.manageUser[selectedTab].pageData[currentPage]) ?? {};


  const cols = Array.from(
    {length: 5},
    (_, i) => users.length > i ? users[i] : {}
  );


  return (
    <thead>
    <TableRow>
      <TableHeader>
        
      </TableHeader>

      {
        cols.map((u, i) => <TableHeader  key={i}
                                        className={`text-center ${loading ? 'bg-gray-200 animate-pulse' : ''}`}>
                                          <div className="flex flex-col"> 
                                          {u.id ? <><div className="truncate">{getFullName(u)}</div> <div className="text-[10px] font-normal text-danger h-[12px]">{u.state === USER_STATE_INACTIVE && "(Inactive)"}</div> </> : ""}
                                          </div>
                                        </TableHeader>)
      }

    </TableRow>
    </thead>
  );
};

